// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'


// 自定义引用bootstrap和zico
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";



import App from './App'
import router from './router'


//在入口的js中引入自己定义的js库



Vue.config.productionTip = false
// // Install BootstrapVue
// Vue.use(BootstrapVue)
// // Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)


/* eslint-disable no-new */
new Vue({
  el: '#app', //el用于指定当前Vue实例为哪个容器服务，值通常为css选择器字符串。
  router,
  components: { App },//注册组件（局部注册）
  template: '<App/>',
  //template网上查了很久，都说是用<app></app>替换index.html里面的<div id="app"></div>，但实验结果并不是这样，太坑了。
//实际上<App/>写法表示要选择的组件，因为components参数里其实可以放多个组件对象，比如：components:{App，App2，App3},如果想用App2，则需要设置template: '<App2/>',这是template参数最常见的用

  created(){

  }
})






// WEBPACK FOOTER //
// ./src/main.js